import { render, staticRenderFns } from "./PaketDataNew.vue?vue&type=template&id=4d8d214d&"
import script from "./PaketDataNew.vue?vue&type=script&lang=js&"
export * from "./PaketDataNew.vue?vue&type=script&lang=js&"
import style0 from "./PaketDataNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports